import { gql } from "@apollo/client";

const ADD_FRONTEND_EVENT = gql`
  mutation AddFrontendEvent($input: AddFrontendEventInput!) {
    addFrontendEvent(input: $input) {
      event {
        id
        key
        payload
        user {
          email
        }
      }
    }
  }
`;

export { ADD_FRONTEND_EVENT };
